import styled from 'styled-components';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

/**
 * A single Breadcrumb Item component.
 *
 * @constructor
 */
const BreadcrumbsItem = styled.li`
    max-width: 100%;
    display: inline;
    span {
        &[type='breadCrumbLink'] {
            &:hover {
                color: ${MIGRATED_COLORS.black} !important;
            }
        }
        &[type='separator'] {
            line-height: 0;
        }
    }
`;

export default BreadcrumbsItem;
